
export const products = [
  {
    id: 1,
    name: 'Vestido Floral Primavera',
    price: 89.99,
    image: 'https://public.readdy.ai/ai/img_res/9984b2ec013892d2343258af00799950.jpg',
    category: 'Vestidos',
    description: 'Vestido floral ligero perfecto para la primavera, con corte elegante y tela suave que fluye naturalmente.',
  },
  {
    id: 2,
    name: 'Blusa de Seda Elegante',
    price: 65.99,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20silk%20blouse%20on%20white%20mannequin%20with%20soft%20studio%20lighting%20and%20clean%20minimal%20white%20background%2C%20elegant%20fashion%20photography%2C%20professional%20product%20display%2C%20sophisticated%20style&width=400&height=500&seq=prod2&orientation=portrait',
    category: 'Blusas',
    description: 'Blusa de seda premium con acabado refinado, ideal para ocasiones especiales o uso diario elegante.',
  },
  {
    id: 3,
    name: 'Pantalón Casual Chic',
    price: 75.99,
    image: 'https://readdy.ai/api/search-image?query=modern%20casual%20chic%20trousers%20on%20white%20mannequin%20with%20professional%20studio%20lighting%20and%20pure%20white%20minimal%20background%2C%20fashion%20product%20photography%2C%20clean%20aesthetic%2C%20contemporary%20style&width=400&height=500&seq=prod3&orientation=portrait',
    category: 'Pantalones',
    description: 'Pantalón versátil con corte moderno, perfecto para combinar con cualquier look casual o formal.',
  },
  {
    id: 4,
    name: 'Falda Midi Romántica',
    price: 69.99,
    image: 'https://readdy.ai/api/search-image?query=romantic%20midi%20skirt%20on%20white%20mannequin%20with%20soft%20natural%20lighting%20and%20clean%20white%20studio%20background%2C%20elegant%20fashion%20photography%2C%20professional%20product%20shot%2C%20feminine%20style&width=400&height=500&seq=prod4&orientation=portrait',
    category: 'Faldas',
    description: 'Falda midi con diseño romántico y elegante, perfecta para crear looks sofisticados y femeninos.',
  },
  {
    id: 5,
    name: 'Chaqueta Denim Moderna',
    price: 95.99,
    image: 'https://readdy.ai/api/search-image?query=modern%20denim%20jacket%20on%20white%20mannequin%20with%20professional%20studio%20lighting%20and%20minimal%20clean%20white%20background%2C%20fashion%20product%20photography%2C%20contemporary%20style%2C%20casual%20elegance&width=400&height=500&seq=prod5&orientation=portrait',
    category: 'Chaquetas',
    description: 'Chaqueta de denim con corte moderno y detalles únicos, esencial en cualquier guardarropa.',
  },
  {
    id: 6,
    name: 'Vestido Cóctel Negro',
    price: 125.99,
    image: 'https://readdy.ai/api/search-image?query=elegant%20black%20cocktail%20dress%20on%20white%20mannequin%20with%20professional%20studio%20lighting%20and%20pure%20white%20minimal%20background%2C%20sophisticated%20fashion%20photography%2C%20luxury%20product%20display%2C%20timeless%20style&width=400&height=500&seq=prod6&orientation=portrait',
    category: 'Vestidos',
    description: 'Vestido de cóctel negro clásico con diseño sofisticado, perfecto para eventos especiales.',
  },
  {
    id: 7,
    name: 'Suéter Cashmere Suave',
    price: 110.99,
    image: 'https://readdy.ai/api/search-image?query=soft%20cashmere%20sweater%20on%20white%20mannequin%20with%20gentle%20studio%20lighting%20and%20clean%20white%20minimal%20background%2C%20luxury%20fashion%20photography%2C%20professional%20product%20shot%2C%20cozy%20elegant%20style&width=400&height=500&seq=prod7&orientation=portrait',
    category: 'Suéteres',
    description: 'Suéter de cashmere ultra suave con textura premium, ideal para los días frescos con estilo.',
  },
  {
    id: 8,
    name: 'Jeans Skinny Premium',
    price: 85.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20skinny%20jeans%20on%20white%20mannequin%20with%20professional%20studio%20lighting%20and%20pure%20white%20minimal%20background%2C%20modern%20fashion%20photography%2C%20clean%20product%20display%2C%20contemporary%20denim%20style&width=400&height=500&seq=prod8&orientation=portrait',
    category: 'Pantalones',
    description: 'Jeans skinny de alta calidad con ajuste perfecto y tela duradera que mantiene su forma.',
  },
  {
    id: 9,
    name: 'Campera Oversize Beige',
    price: 119.99,
    image: 'https://readdy.ai/api/search-image?query=oversized%20beige%20women%20jacket%20on%20white%20mannequin%20with%20soft%20studio%20lighting%20and%20clean%20white%20minimal%20background%2C%20trendy%20fashion%20photography%2C%20professional%20product%20shot%2C%20casual%20chic%20style%2C%20warm%20neutral%20tones&width=400&height=500&seq=prod9&orientation=portrait',
    category: 'Camperas',
    description: 'Campera oversize en tono beige, perfecta para looks casuales con mucho estilo y comodidad.',
  },
  {
    id: 10,
    name: 'Campera de Cuero Negro',
    price: 149.99,
    image: 'https://readdy.ai/api/search-image?query=sleek%20black%20leather%20women%20jacket%20on%20white%20mannequin%20with%20dramatic%20studio%20lighting%20and%20pure%20white%20minimal%20background%2C%20edgy%20fashion%20photography%2C%20professional%20product%20display%2C%20rock%20chic%20style%2C%20glossy%20texture&width=400&height=500&seq=prod10&orientation=portrait',
    category: 'Camperas',
    description: 'Campera de cuero negro con corte ajustado y detalles metálicos, un clásico que nunca pasa de moda.',
  },
  {
    id: 11,
    name: 'Campera Bomber Floral',
    price: 105.99,
    image: 'https://readdy.ai/api/search-image?query=floral%20bomber%20jacket%20women%20on%20white%20mannequin%20with%20soft%20natural%20studio%20lighting%20and%20clean%20white%20background%2C%20feminine%20fashion%20photography%2C%20professional%20product%20shot%2C%20colorful%20floral%20embroidery%2C%20spring%20style&width=400&height=500&seq=prod11&orientation=portrait',
    category: 'Camperas',
    description: 'Campera bomber con estampado floral vibrante, ideal para darle un toque especial a cualquier outfit.',
  },
  {
    id: 12,
    name: 'Campera Trench Clásica',
    price: 135.99,
    image: 'https://readdy.ai/api/search-image?query=classic%20trench%20coat%20women%20on%20white%20mannequin%20with%20elegant%20studio%20lighting%20and%20pure%20white%20minimal%20background%2C%20timeless%20fashion%20photography%2C%20professional%20product%20display%2C%20sophisticated%20beige%20trench%2C%20belted%20waist&width=400&height=500&seq=prod12&orientation=portrait',
    category: 'Camperas',
    description: 'Trench clásico de corte elegante con cinturón, una pieza atemporal para cualquier temporada.',
  },
];
